import { useState, useEffect } from "react"

export default function useNetworkStatus() {
  const [connectionStatus, setConnectionStatus] = useState(null)

  useEffect(() => {
    const checkInternetConnection = async () => {
      try {
        const response = await fetch("https://www.google.com", {
          method: "HEAD",
          mode: "no-cors",
        })

        if (response.type === "opaque") {
          setConnectionStatus("online")
        } else {
          setConnectionStatus("offline")
        }
      } catch (error) {
        setConnectionStatus("offline")
      }
    }

    // Initial check
    if (navigator.onLine) {
      checkInternetConnection()
    } else {
      setConnectionStatus("offline")
    }

    // Listen for online/offline events in the Electron environment
    if (
      typeof process !== "undefined" &&
      process.versions &&
      process.versions.electron
    ) {
      window.addEventListener("online", checkInternetConnection)
      window.addEventListener("offline", () => setConnectionStatus("offline"))

      // Cleanup event listeners when the component unmounts
      return () => {
        window.removeEventListener("online", checkInternetConnection)
        window.removeEventListener("offline", () =>
          setConnectionStatus("offline"),
        )
      }
    }
  }, [])

  return { connectionStatus }
}
